import { useDispatch, useSelector } from 'react-redux';

import MessageBox from '../../nextgen/common/MessageBox/MessageBox';
import { getMessageBoxProps } from '../../main/selectors';
import { hideMessageBox } from '../../main/actions';

export default function SingletonMessageBox() {
  const dispatch = useDispatch();
  let messageBoxProps = useSelector(getMessageBoxProps);

  function onOk() {
    if (messageBoxProps.onOk) messageBoxProps.onOk();
    dispatch(hideMessageBox());
  }

  function onCancel() {
    if (messageBoxProps.onCancel) messageBoxProps.onCancel();
    dispatch(hideMessageBox());
  }

  function onClose() {
    if (messageBoxProps.onClose) messageBoxProps.onClose();
    dispatch(hideMessageBox());
  }

  let hasCloseButton = true;
  if (messageBoxProps.hasCloseButton !== undefined && messageBoxProps.hasCloseButton !== null)
    hasCloseButton = messageBoxProps.hasCloseButton;

  return (
    <MessageBox
      onOk={onOk}
      onCancel={onCancel}
      onClose={onClose}
      buttons={messageBoxProps.buttons}
      buttonsCaption={messageBoxProps.buttonsCaption}
      show={messageBoxProps.show}
      text={messageBoxProps.message}
      title={messageBoxProps.title}
      closeButton={hasCloseButton}
    />
  );
}
